import React from 'react'
import SVG from 'react-inlinesvg'
import { HTMLMotionProps, motion } from 'motion/react'
import { cn } from '../../utils/cn'

// the motion props let a parent animate the button, without them it is a plain button
type CloseButtonProps = Omit<HTMLMotionProps<'button'>, 'onClick' | 'className'> & {
  onClick: () => void
  className?: string
}

const CloseButton: React.FC<CloseButtonProps> = ({ onClick, className, ...motionProps }) => {
  return (
    <motion.button
      {...motionProps}
      onClick={onClick}
      className={cn(
        'group absolute right-[4%] top-[2vh] z-[4] flex size-[40px] items-center justify-center rounded-full border border-solid border-white/50 bg-red p-0 text-[length:inherit] text-white shadow-floating [transition:0.2s] tall-xxs:size-[50px] tall-xs:top-[10vh] xs:tall-sm:top-[18vh] sm:top-[10.5vh] sm:size-[70px] md:size-[80px] xl:size-[90px] xxl:top-[15vh] xxl:size-[112px] [&.active]:bg-white [&.fade-in]:animate-[fade-in-x50_0.5s_ease_forwards] [&.fade-out]:animate-[fade-out-x50_0.5s_ease_forwards]',
        className,
      )}
    >
      <SVG
        className="w-[45%] group-[.active]:size-full group-[.active]:fill-black group-[.active]:text-black"
        src="/icons/x.svg"
      />
    </motion.button>
  )
}

export default CloseButton
